console.log("[application.ts] Loading application bundle...");
import ReactOnRails from "react-on-rails";
import {
  ContractorSitePage,
  MainAppPage,
  AdminAppPage,
  ContractorSeoIndexPage,
  ContractorSeoArticlePage,
  ContractorSeoProjectPage,
} from "../src/pages";
import "../src/styles/application.css";

console.log("[application.ts] Registering React components...");
ReactOnRails.register({
  MainAppPage,
  ContractorSitePage,
  AdminAppPage,
  ContractorSeoIndexPage,
  ContractorSeoArticlePage,
  ContractorSeoProjectPage,
});

// Log when hydration completes
if (typeof window !== "undefined") {
  window.addEventListener("DOMContentLoaded", () => {
    console.log(
      "[application.ts] DOMContentLoaded - React hydration should happen now",
    );
  });
}
